// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  overflow-x: hidden;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

kbd {
  background-color: transparent;
  color: #243547;
  border: none;
  text-decoration: none;
  box-shadow: none;
}

.main {
  width: 100%;
  height: 600px;
  padding: 0px 20px;
  text-align: left;
  /* font-family: SFProText; */
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,0DAA0D;AAC5D","sourcesContent":[".App {\n  text-align: center;\n  overflow-x: hidden;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\nkbd {\n  background-color: transparent;\n  color: #243547;\n  border: none;\n  text-decoration: none;\n  box-shadow: none;\n}\n\n.main {\n  width: 100%;\n  height: 600px;\n  padding: 0px 20px;\n  text-align: left;\n  /* font-family: SFProText; */\n  font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
